export default __webpack_public_path__ + "static/media/logo.a6deb73f.png";